<div class="phone-number-form-field">
  <span class="phone-number-form-field__label">
    {{ labelText() | translate }}
  </span>
  <div
    class="phone-number-form-field__input-wrapper"
    [class.phone-number-form-field__input-wrapper--invalid]="control().invalid && control().dirty"
  >
    <div
      role="button"
      tabindex="0"
      class="phone-number-form-field__country-code-selector phone-number-form-field__short-info"
      (click)="isSelectorDisplayed.set(true)"
    >
      <span>
        {{ shortInfoText() }}
      </span>
      <app-icon [icon]="iconName.CHEVRON_DOWN" />
    </div>
    @if (isSelectorDisplayed()) {
      <div
        role="button"
        tabindex="0"
        class="phone-number-form-field__country-code-selector phone-number-form-field__custom-selector"
        (click)="changeCountry($event)"
        (mouseleave)="isSelectorDisplayed.set(false)"
      >
        @for (country of countries(); track $index) {
          <div
            class="phone-number-form-field__custom-selector-item"
            [attr.data-item-index]="$index"
          >
            {{ country.name + ' ' + country.phoneCode }}
          </div>
        }
      </div>
    }
    <input
      type="tel"
      [formControl]="control()"
      class="phone-number-form-field__phone-input"
      [mask]="phoneMaskOptions().mask"
      [validation]="phoneMaskOptions().isValidationOn"
    />
  </div>

  @if (control().status === 'INVALID') {
    <span class="phone-number-form-field__error-message">
      {{ tryGetFirstErrorKey() | translate }}
    </span>
  }
</div>
